import { httpClient } from '@/services/http/httpClient'

export type DeleteTaskParams = {
  projectId: string
  id: string
}

export async function deleteTask({
  projectId,
  id,
}: DeleteTaskParams): Promise<void> {
  await httpClient.delete(`/projects/project-tasks/${projectId}/${id}`)
}
